import store from '../store/Store';
import loc from 'owa-localize';
import {
    bookwithme_LeadTimeWindowWarningMessage,
    bookwithme_MinLeadTimeGreaterThanMaxLeadTimeWarningMessage,
} from '../components/compose/ComposeServiceFull.locstring.json';
export default function checkErrorEditStateMinAndMax(): string {
    const minutesInADay = 24 * 60;
    const minLeadTimeInMinutes = store.meetingTypeEditState.schedulingPolicy.leadTimeInMinutes;
    const maxLeadTimeInMinutes =
        store.meetingTypeEditState.schedulingPolicy.endOfBookingWindowInDays * minutesInADay;
    if (
        minLeadTimeInMinutes > maxLeadTimeInMinutes &&
        store.meetingTypeEditState.validateMinAndMax.hasError
    ) {
        return loc(bookwithme_MinLeadTimeGreaterThanMaxLeadTimeWarningMessage);
    } else if (
        maxLeadTimeInMinutes - minLeadTimeInMinutes < minutesInADay &&
        store.meetingTypeEditState.validateMinAndMax.hasError
    ) {
        return loc(bookwithme_LeadTimeWindowWarningMessage);
    } else {
        return '';
    }
}
